import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/*

  All iOS, us/uk — appstore button
  iOS, from other countries — Available in the US and UK only. Enter your email to try beta on iPhone 5s and above.
  Android, all countries — Leave your e-mail to get notified when Android app launches.
  Other mobile devices uk/us — appstore button
  Other mobile devices, from other countries - Available in the US and UK only. Enter your email to try beta on iPhone 5s and above.
  Desktop, us/uk — appstore button + sms
  Desktop, from other countries - Available in the US and UK only. Enter your email to try beta on iPhone 5s and above.

*/
import classnames from 'classnames';
import filter from 'lodash/filter';
import get from 'lodash/get';
import identity from 'lodash/identity';
import pickBy from 'lodash/pickBy';
import React, { Component } from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import countries from 'constants/SupportedCountries.json';
import InviteForm from './InviteForm';
import StoreButton from './StoreButton';
import '../styles/availability.scss';
const messages = defineMessages({
    reward: 'Join now and{br}receive your first',
    gte_iphone_model_warning: 'iPhone 7 or newer',
    invite_form_title: 'Available in selected markets only. Enter your email to be notified when I come to your country',
    invite_form_success: 'Thanks! We’ll be in touch when we land near you!',
});
const countrySelector = (state) => state.config.country;
const deviceSelector = (state) => get(state, 'home.device', {});
const mapStateToProps = createStructuredSelector({
    country: countrySelector,
    device: deviceSelector,
});
class Availability extends Component {
    render() {
        const availableCountries = filter(countries, (c) => !c.unsupported).map((c) => c.country);
        return (_jsx("div", { className: classnames('availability', this.props.className), children: ~availableCountries.indexOf(this.props.country)
                ? this._renderSupportedCounties()
                : this._renderUnsupportedCounties() }));
    }
    _renderSupportedCounties() {
        const isAndroid = this.props.device.isAndroid;
        const storeButtonMobileProps = pickBy({
            campaign: this.props.campaign,
            className: this.props.storeButtonClassName,
            link: this.props.storeButtonLink,
            from: this.props.from,
        }, identity);
        const storeButtonDesktopProps = pickBy({
            campaign: this.props.campaign,
            className: this.props.storeButtonClassName,
            from: this.props.from,
        }, identity);
        return (_jsx("div", { className: "availability__widget", children: this.props.storeButton ? (_jsxs("div", { className: "availability__widget__link", children: [this.props.rewardInvitee ? (_jsxs("div", { className: "availability__widget__link__reward only-mobile", children: [_jsx(FormattedMessage, Object.assign({}, messages.reward)), _jsxs("strong", { children: [_jsx("i", { className: "icon-swc" }), "5"] })] })) : null, _jsxs("div", { className: classnames('availability__widget__link__download', { 'only-desktop': isAndroid }), children: [_jsx(StoreButton, Object.assign({}, storeButtonDesktopProps, { type: "AppStore", className: "only-desktop" })), _jsx(StoreButton, Object.assign({}, storeButtonMobileProps, { type: "AppStore", className: "only-mobile" })), _jsx("br", {}), _jsx("em", { children: _jsx(FormattedMessage, Object.assign({}, messages.gte_iphone_model_warning)) })] }), _jsxs("div", { className: classnames('availability__widget__link__download', { 'only-desktop': !isAndroid }), children: [_jsx(StoreButton, Object.assign({}, storeButtonDesktopProps, { type: "GooglePlay", className: "only-desktop" })), _jsx(StoreButton, Object.assign({}, storeButtonMobileProps, { type: "GooglePlay", className: "only-mobile" })), _jsx("br", {})] })] })) : null }));
    }
    _renderUnsupportedCounties() {
        return (_jsx("div", { className: "availability__widget", children: _jsx("div", { className: "availability__widget__form", children: _jsx(FormattedMessage, Object.assign({}, messages.invite_form_title, { children: (title) => (_jsx(FormattedMessage, Object.assign({}, messages.invite_form_success, { children: (success) => _jsx(InviteForm, { type: this.props.country, title: title, success: success }) }))) })) }) }));
    }
}
Availability.defaultProps = {
    rewardInvitee: false,
    storeButton: true,
    storeButtonLink: null,
    storeButtonClassName: null,
};
export default connect(mapStateToProps)(Availability);
